module.exports = __webpack_public_path__ + "img/logo.7534c3e2.png";